import { Container } from "react-bootstrap";


export default function Loading({ height }) {
    return (
        <Container style={{ height: height || "90vh" }} className="d-flex justify-content-center align-items-center">
            <p className="m-0 fw-bold">Cargando...</p>
        </Container>
    )
}